import moment from "moment";
import { Link } from "react-router-dom";
import { ROUTE_FILE_LIST_CONFIGURATION } from "../../../core/route/ui.routes";

export const fileConfigColumns = (history:any) => [
  {
    title: "S. No.",
    key: "sno",
    render: (_:any, __:any, index:any)=>index+1,
    width: '90px'
  },
  {
    title: "File Category",
    key: "file_category",
    // dataIndex: "file_category",
    render: (record:any)=>{
      return <><a onClick={()=>history.push(ROUTE_FILE_LIST_CONFIGURATION(record?.id, record?.file_category))}>{record?.file_category}</a></>
    }
  },
  {
    title: "Date of Last Upload",
    key: "last_uploaded_at",
    dataIndex: "last_uploaded_at",
    render: (_:any)=>moment(_).format("DD MMM'YY, hh:mm A")
  },
  {
    title: "Last Uploaded Status",
    key: "last_uploaded_at",
    dataIndex: "last_uploaded_status",
  },
  {
    title: "Last Uploaded By",
    key: "last_uploaded_by",
    dataIndex: "last_uploaded_by",
  },
];

export const fileConfigFilterForm = (fileCategories: any = []) => [
  {
    type: "Input",
    name: "search",
    placeholder: "Search File Category Name",
    colSpan: 10,
    allowClear: true
  },
  {
    type: "Select",
    name: "file_category",
    colSpan: 6,
    placeholder: "All File Categories",
    options: fileCategories,
    allowClear: true
  },
];

export const fileListConfigColumns = (category_name: string) => [
  {
    title: "S. No.",
    key: "sno",
    render: (_:any, __:any, index:any)=>_.sno,
    width: '90px'
  },
  {
    title: "File Name",
    key: "filename",
    // dataIndex: "",
    render: (rec:any)=><a href={rec?.file_url}>{rec?.filename}</a>
  },
  {
    title: "Date of Upload",
    key: "uploaded_at",
    dataIndex: "uploaded_at",
    render: (_:any)=>moment(_).format("DD MMM'YY hh:mm A")
  },
  {
    title: "File Category",
    key: "category_id",
    render : () => category_name
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "Uploaded By",
    key: "uploaded_by",
    dataIndex: "uploaded_by",
  },
  {
    title: "Action",
    key: "action",
    // dataIndex: "uploaded_by",
    // className: 'capitalize'
    render: (rec:any)=>rec?.error_file_url && rec?.status == 'Rejected' ? <a href={rec?.error_file_url}>Download Error File</a> : "--"
  },
];

export const fileListConfigFilterForm = (statusList: any = []) => [
  {
    type: "Input",
    name: "search",
    placeholder: "Search File Name",
    colSpan: 10,
    allowClear: true
  },
  {
    type: "Select",
    name: "status",
    colSpan: 6,
    placeholder: "All Status",
    options: statusList,
    allowClear: true
  },
  {
    type: "RangePicker",
    name: "range",
    colSpan: 8,
    allowClear: true
    // placeholder: "Date Range"
  },
];

export const allTableConfigs = {
  "file-configuration": {
    columns: fileConfigColumns,
    filterForm: fileConfigFilterForm,
  },
  "file-list": {
    columns: fileListConfigColumns,
    filterForm: fileListConfigFilterForm,
  },
};
